/**
 * Size Recs Queries
 */

import gql from 'graphql-tag'

export const getSizeRecRequestsQuery = gql`
  query getMySizeRecRequests(
    $limit: Int
    $offset: Int
    $order: String
    $orderAs: String
    $status: String
    $searchText: String
    $startDate: String
    $endDate: String
  ){
    sizeRequests: getMySizeRecRequests(
    limit: $limit
    offset: $offset
    order: $order
    orderAs: $orderAs
    status: $status
    searchText: $searchText
    startDate: $startDate
    endDate: $endDate
    ) {
      fullCount
      list: requests {
        id
        shortId: short_id
        requestedAt: created_at
        items: design_count
        scan
        status
        recommender
        responsedAt: responsed_at
      }
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/SizeRecs/data.ts